import { render, staticRenderFns } from "./RbacTab.vue?vue&type=template&id=116483f9&scoped=true&"
import script from "./RbacTab.vue?vue&type=script&lang=js&"
export * from "./RbacTab.vue?vue&type=script&lang=js&"
import style0 from "./RbacTab.vue?vue&type=style&index=0&id=116483f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116483f9",
  null
  
)

export default component.exports